import $ from 'jquery';

$(() => {
  const stickyNewsletter = $(".sticky-newsletter");
  if (stickyNewsletter.length) {
    stickyNewsletter.each((i, stickyEl) => {
      const sticky = $(stickyEl);
      const newsletterButton = sticky.children('.newsletter-button');
      newsletterButton.on('click', function() {
        sticky.toggleClass('show-modal');
      })
      const background = sticky.children('.newsletter-bg');
      background.on('click', function(e) {
        e.stopPropagation();
        sticky.removeClass('show-modal');
      })
      const modal = background.children('.newsletter-modal');
      modal.on('click', function(e) {
        e.stopPropagation();
      })
      const closeButton = modal.children('.close-button');
      closeButton.on('click', function() {
        console.log('closing newsletter modal');
        sticky.removeClass('show-modal');
      })
    });
  }
});